import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notfoundpage',
  templateUrl: './notfoundpage.component.html',
  styleUrls: ['./notfoundpage.component.scss']
})
export class NotfoundpageComponent implements OnInit {

  constructor(private router: Router, public translate: TranslateService) { }

  ngOnInit() {
  }
  backToHome(){
    this.router.navigateByUrl('/home');
  }

}
